import styled from 'styled-components'
import { theme } from '@dasa-health/components-react'

export const CustomSpacing = styled.div`
    margin-top: 1.5rem;

    @media (min-width: ${theme.breakpoints[2]}) {
        margin-top: 2rem;
    }
`
